module.exports = __webpack_public_path__ + "img/catarina-viegas.ddc197cb.jpg";